import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import Vue from "vue";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_DOCUMENT_COMMENTS = "SET_DOCUMENT_COMMENTS";
export const SET_DOCUMENT_CLASSIFICATIONS = "SET_DOCUMENT_CLASSIFICATIONS";
export const ADD_DOCUMENT_COMMENT = "ADD_DOCUMENT_COMMENT";
export const REMOVE_DOCUMENT_COMMENT = "REMOVE_DOCUMENT_COMMENT";
export const ADD_DOCUMENTS_TO_CLASSIFICATION = "ADD_DOCUMENTS_TO_CLASSIFICATION";
export const SET_CLIENT_DETAILS = "SET_CLIENT_DETAILS";
export const SET_TOKEN = "SET_TOKEN";
const mutations = {
  [SET_CLIENT_DETAILS]: (state, {
    clientDetails
  }) => {
    Vue.set(state, "clientDetails", clientDetails);
  },
  [SET_TOKEN]: (state, {
    token
  }) => {
    Vue.set(state, "token", token);
  },
  [SET_DOCUMENTS]: (state, {
    documents
  }) => {
    Vue.set(state, "documents", documents);
  },
  [SET_DOCUMENT_COMMENTS]: (state, {
    comments
  }) => {
    Vue.set(state, "comments", comments);
  },
  [SET_DOCUMENT_CLASSIFICATIONS]: (state, {
    classifications
  }) => {
    Vue.set(state, "classifications", classifications);
  },
  [ADD_DOCUMENT_COMMENT]: (state, {
    documentId,
    comment
  }) => {
    Vue.set(state.comments.byId, comment.id, comment);
    state.documents.byId[documentId].comments.push(comment.id);
  },
  [REMOVE_DOCUMENT_COMMENT]: (state, {
    documentId,
    commentId
  }) => {
    var _state$documents$byId, _documentComments$fil;
    Vue.delete(state.comments.byId, commentId);
    const documentComments = (_state$documents$byId = state.documents.byId) == null ? void 0 : _state$documents$byId[documentId].comments;
    state.documents.byId[documentId].comments = (_documentComments$fil = documentComments == null ? void 0 : _filterInstanceProperty(documentComments).call(documentComments, id => id !== commentId)) != null ? _documentComments$fil : [];
  },
  [ADD_DOCUMENTS_TO_CLASSIFICATION]: (state, {
    documents,
    documentRequestId
  }) => {
    for (const document of documents) {
      Vue.set(state.documents.byId, document.documentId, document);
    }
    const documentClassification = state.classifications.byId[documentRequestId];
    documentClassification.documents.push(..._mapInstanceProperty(documents).call(documents, ({
      documentId
    }) => documentId));
  }
};
export default mutations;